export default __webpack_public_path__ + "static/media/tambola.1b592a1d.png";